import currencyFormatter from 'currency-formatter'


// This is a temporary fix until currencyCode is handled on a global state level
export const formatMoneyByCountry = (countryCode, money) => {
    return currencyFormatter.format(money, { code: countryCode });
}

export default formatMoneyByCountry